import React, { useContext, useEffect, useState } from 'react';
import { Box, Divider, Grid } from '@material-ui/core';
import SpText from '../../../components/atoms/SpText';
import SpTextInput from '../../../components/atoms/SpTextInput';
import { useForm } from 'react-hook-form';
import { removeReservation, updateReservation } from '../../../models/actions/Reservations';
import { styled } from '../../../components/styled';
import SpDialog from '../../../components/atoms/SpDialog';
import SpButton from '../../../components/atoms/SpButton';
import { theme } from '../../../components/theme';
import { withSnackbar } from '../../../components/atoms/SpSnackBar';
import { labels } from '../../shared/translations';
import { nanoid } from 'nanoid';
import { useHistory } from 'react-router-dom';
import { UserSessionContext } from '../../../App';
const AgendaCalendarEventCard = (props) => {
  const [openDeleteActivity, setOpenDeleteActivity] = useState(false);
  const [activityToBeDeleted, setActivityToBeDeleted] = useState();
  const history = useHistory();

  const { authData, setAuthData } = useContext(UserSessionContext);

  const { event, setOpenDetailActivity, openDetailActivity, fetchData, patientId, updateActivity } = props;
  console.log(event);
  const { handleSubmit, register, setValue, getValues } = useForm({
    shouldUnregister: false
  });

  const deleteCalendarActivity = async (e) => {
    e.stopPropagation();
    try {
      const result = await removeReservation({ id_reservation: activityToBeDeleted }, authData.accessToken);
      if (result.error) {
        props.snackbarShowErrorMessage(result.error);
      } else {
        await fetchData();
        // let newArray = openDetailActivity;
        // newArray.find((elem) => elem.id === event.id).value = false;
        setOpenDetailActivity(false);
        props.snackbarShowMessage(result.message);
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    console.log(event);
    setActivityToBeDeleted(event.id);
  }, []);

  const LabelValue = (props) => (
    <Grid
      direction="column"
      style={{ marginBottom: '5px' }}
    >
      <SpText variant="dialogReservationDetailTitle">{props.label}</SpText>
      {props.value && <SpText variant="dialogReservationDetailValue">{props.value}</SpText>}
    </Grid>
  );

  return (
    <>
      <Grid
        container
        direction="column"
        style={{
          padding: 15,
          background: '#FFF',
          minWidth: 800,
          width: '100%'
        }}
      >
        <SpText variant="h1PageSubtitle">{`L'utente ${event.user?.first_name ? event.user?.first_name.toString() : event.user?.name.toString()}  ${event.user?.second_name?.toString()} ha prenotato le seguenti ebikes:`}</SpText>

        {event.bikes.map((bike) => (
          <LabelValue
            label={`Codice ebike: ${bike?.code?.toString()}`}
            value={`Taglia: ${bike?.size?.toString()}`}
          />
        ))}
        <SpButton
          buttonType="cancel"
          style={{ flex: 'auto' }}
          text={labels.patient.patientPlan.activityDetailDialog.openDeleteButtonActivity}
          variant="h1PageTitle"
          onClick={(e) => {
            e.stopPropagation();
            setOpenDeleteActivity(true);
          }}
        />
      </Grid>
      <SpDialog
        open={openDeleteActivity}
        setOpen={setOpenDeleteActivity}
        title={'Elimina prenotazione'}
      >
        <Grid
          container
          spacing={2}
          direction="column"
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="h4ComponentLabel">{'Sei sicuro di voler eliminare la prenotazione?'}</SpText>
          </Grid>
          <Grid
            item
            xs={12}
            container
            spacing={2}
          >
            <Grid
              item
              xs={6}
            >
              <SpButton
                buttonType="cancel"
                text={labels.patient.patientPlan.activityDetailDialog.confirm}
                variant="h1PageTitle"
                onClick={(e) => deleteCalendarActivity(e)}
              />
            </Grid>
            <Grid
              item
              xs={6}
            >
              <SpButton
                buttonType="accept"
                text={labels.patient.patientPlan.activityDetailDialog.deny}
                variant="h1PageTitle"
                onClick={() => setOpenDeleteActivity(false)}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
    </>
  );
};

export default withSnackbar(AgendaCalendarEventCard);
